import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './CarrierModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import personImg from '../../assets/images/person-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneImg from '../../assets/images/phone-icon.png';
import plusImg from '../../assets/images/plus-icon.png';
import sideBySideImg from '../../assets/images/side-by-side-icon.png';
import stackedImg from '../../assets/images/stacked-icon.png';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import saveImg from '../../assets/images/save-icon.png';
import historyImg from '../../assets/images/history-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Modal from '../UI/Modal/Modal';

class CarrierModal extends Component {

  createInputConfig = (elementType,
    elementConfig,
    label,
    value = '',
    validation = {},
    valid = true,
    extraAction = null,
    extraClass = null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraAction: extraAction,
      extraClass: extraClass,
      touched: false,
      errorMessage: null
    });
  }

  updateTripHistory(ev, id, tripId, status, outcome, phoneNumber) {
    ev.preventDefault();
    let data = {
      id: id,
      tripId: tripId,
      status: status,
      outcome: outcome,
      phoneNumber: phoneNumber
    }
    axios({
      method: 'post',
      data: data,
      url: '/api/v1/carriers/history/update',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        const updatedTripHistory = { ...this.state.tripCarrierHistory };
        const updatedHistory = [...updatedTripHistory.tripCarrier.value];
        for (let i = 0; i < updatedHistory.length; i++) {
          if (updatedHistory[i].id === response.data.id) {
            updatedHistory[i] = response.data;
            break;
          }
        }
        updatedTripHistory.tripCarrier.value = updatedHistory;
        this.setState({ tripCarrierHistory: updatedTripHistory });
        this.props.addNotification("Звернення до Перевізника збережено.", "Success");
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/history/update'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  getCarrier(carrierId) {
    for (let i = 0; i < this.state.carrierHolderForm.carrier.elementConfig.options.length; i++) {
      if (parseInt(this.state.carrierHolderForm.carrier.elementConfig.options[i].value) === parseInt(carrierId)) {
        return this.state.carrierHolderForm.carrier.elementConfig.options[i].displayValue;
      }
    }
  }

  blankTripCarrierHistory(ev) {
    ev.preventDefault();
    axios({
      method: 'get',
      url: '/api/v1/carriers/carrier?id=' + parseInt(this.state.carrierHolderForm.carrier.value ? this.state.carrierHolderForm.carrier.value : 0),
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        let carrierName = response.data.id <= 0 ? " " : response.data.id + " | ";
        carrierName += this.getAttribute(response.data, "okpo") + " | ";
        carrierName += this.getAttribute(response.data, "name") + " | ";
        carrierName += this.getAttribute(response.data, "name_partner") + " | ";
        carrierName += this.getAttribute(response.data, "name_ls");

        let data = {
          name: carrierName,
          tripId: parseInt(this.props.card.trip.substring(1, this.props.card.trip.length)),
          status: "-",
          phoneType: "",
          phoneNumber: "",
          outcome: null,
          customisable: true
        }

        axios({
          method: 'post',
          data: data,
          url: '/api/v1/carriers/trip',
          headers: { 'Authorization': 'Bearer ' + this.props.access_token },
        })
          .then(response => {
            const updatedTripHistory = { ...this.state.tripCarrierHistory };
            updatedTripHistory.tripCarrier.value.splice(0, 0, response.data);
            this.setState({ tripCarrierHistory: updatedTripHistory });
          })
          .catch(error => {
            console.log(error);
            this.setState({ loading: false });
          });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/trip'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  customTripCarrierHistory(ev, name) {
    ev.preventDefault();
    let data = {
      name: name,
      tripId: parseInt(this.props.card.trip.substring(1, this.props.card.trip.length)),
      status: "-",
      phoneType: "",
      phoneNumber: "",
      outcome: null,
      customisable: true
    }

    axios({
      method: 'post',
      data: data,
      url: '/api/v1/carriers/trip',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const updatedTripHistory = { ...this.state.tripCarrierHistory };
        updatedTripHistory.tripCarrier.value.splice(0, 0, response.data);
        this.setState({ tripCarrierHistory: updatedTripHistory });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/trip'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  call(ev, carrier, phoneType, phoneNumber) {
    ev.preventDefault();

    let rawPhone = phoneNumber.replace(/\D+/g, "");
    if (rawPhone.length > 10) {
      rawPhone = rawPhone.substring(rawPhone.length - 10, rawPhone.length);
    }

    let data = {
      name: carrier,
      tripId: parseInt(this.props.card.trip.substring(1, this.props.card.trip.length)),
      status: "-",
      phoneType: phoneType,
      phoneNumber: rawPhone,
      outcome: null,
      customisable: false
    }

    axios({
      method: 'post',
      data: data,
      url: '/api/v1/carriers/trip',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const updatedTripHistory = { ...this.state.tripCarrierHistory };
        const updatedHistory = [...updatedTripHistory.tripCarrier.value];
        updatedHistory.unshift({ ...response.data, outcome: null, status: "-" });
        updatedTripHistory.tripCarrier.value = updatedHistory;
        this.setState({ tripCarrierHistory: updatedTripHistory });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/trip'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  savePhone(ev, carrier, phoneType, phoneNumber) {
    ev.preventDefault();
    let data = {
      carrierId: carrier,
      phoneType: phoneType,
      phoneNumber: phoneNumber
    }

    this.setState({ loading: true });
    axios({
      method: 'post',
      data: data,
      url: '/api/v1/carriers/phones',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.props.addNotification("Телефон Перевізника був збережений.", "Success");
        this.setState({ loading: false });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/phones'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  sideBySide(ev) {
    ev.preventDefault();
    this.props.onSetSideBySide(!this.props.sideBySideMode);
  }

  deleteCarrier(ev) {
    ev.preventDefault();
    let carrier = null;
    let index = -1;
    for (let i = 0; i < this.props.carriers.length; i++) {
      if (this.state.carrierHolderForm.carrier.value === this.props.carriers[i].id) {
        carrier = this.props.carriers[i];
        index = i;
        break;
      }
    }
    if (carrier === null) {
      return;
    }

    axios({
      method: 'get',
      url: '/api/v1/carriers/delete?carrierId=' + carrier.id,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        const updatedCarriers = [...this.props.carriers];
        updatedCarriers.splice(index, 1);
        this.props.onSetCarriers(updatedCarriers);
        this.props.addNotification("Перевізник видалений успішно.", "Success");
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/delete?carrierId=' + carrier.id
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  state = {
    localCard: null,
    loading: false,
    showHistory: false,
    driver: -1,
    history: null,
    historyLoading: false,
    carrierHolderForm: {
      carrier: this.createInputConfig(
        'carriers',
        {
          options: []
        },
        'Перевізник: ',
        '',
        { required: false },
        true,
        {
          edit: (ev) => this.editCarrier(ev),
          del: (ev) => this.deleteCarrier(ev),
          new: (ev) => this.props.onShowNewCarrier({}),
          getCarriers: (ev) => this.getCarriers(ev)
        }),
    },
    tripCarrierHistory: {
      tripCarrier: this.createInputConfig(
        'trip-carrier-history',
        { labelClass: classes.InlineLabel },
        'Історія Рейсу: ',
        [],
        { required: false },
        true,
        {
          updateHistory: (ev, id, tripId, status, outcome, phoneNumber) => this.updateTripHistory(ev, id, tripId, status, outcome, phoneNumber),
          call: (ev, carrier, phoneType, phoneNumber) => this.call(ev, carrier, phoneType, phoneNumber),
          blankHistoryRecord: (ev) => this.blankTripCarrierHistory(ev),
          copyHistoryRecord: (ev, name) => this.customTripCarrierHistory(ev, name),
          delete: (ev, index) => this.deleteHistory(ev, index)
        })
    },
    carrierForm: {
      phones: this.createInputConfig(
        'phones',
        {
          options: []
        },
        'Телефони Перевізника: ',
        '',
        {},
        true,
        {
          call: (ev, carrier, phoneType, phoneNumber) => this.call(ev, carrier, phoneType, phoneNumber),
          savePhone: (ev, carrier, phoneType, phoneNumber) => this.savePhone(ev, carrier, phoneType, phoneNumber)
        })
    },
    driverForm: {
      phones: this.createInputConfig(
        'driver-phones',
        {
          options: []
        },
        'Телефони Водія: ',
        '',
        {},
        true,
        { call: (ev, driver, phoneType, phoneNumber) => this.call(ev, driver, phoneType, phoneNumber) })
    },
    commentForm: {
      comment: this.createInputConfig(
        'input',
        { placeholder: 'Коментар...' },
        '',
        '',
        { required: false },
        true,
        null,
        classes.InlineLimited)
    }
  }

  deleteHistory(ev, index) {
    ev.preventDefault();
    const obj = { ...this.state.tripCarrierHistory.tripCarrier.value[index] };
    axios({
      method: 'post',
      data: { ...obj },
      url: '/api/v1/carriers/history/delete',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.getTripHistory(this.props.card.trip);
      })
      .catch(error => {
        console.log(error);
        this.setState({ historyLoading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/history/delete'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  getCarriers() {
    axios({
      method: 'get',
      url: '/api/v1/carriers',
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        if (this.props.carriers.length !== response.data.length) {
          const carriers = [...response.data];
          let negId = -1;
          for (let i = 0; i < carriers.length; i++) {
            if (!carriers[i].id) {
              carriers[i].id = negId;
              negId -= 1;
            }
          }
          this.props.onSetCarriers(carriers);
        }
      })
      .catch(error => {
        console.log(error.response);
        if (error.response && error.response.status === 401) {
          this.getCarriers();
        } else if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Сервер не відповідає.", "Danger");
        }
      });
  }

  getAttribute(carrier, attr) {
    if (carrier[attr]) {
      return carrier[attr];
    }
    return "";
  }

  getPhones(carrierId) {
    if (carrierId === "-" || carrierId === "" || carrierId === null || carrierId === undefined) {
      return;
    }
    if (!this.state.loading) {
      this.setState({ loading: true });
    }

    axios({
      method: 'get',
      url: '/api/v1/carriers/phones?id=' + carrierId,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        const updatedCarrierForm = { ...this.state.carrierForm };
        let phones = this.parsePhones(response.data);
        for (let i = 0; i < phones.length; i++) {
          phones[i] = { ...phones[i], carrier: this.state.carrierHolderForm.carrier.value };
        }
        updatedCarrierForm.phones.value = phones;
        this.setState({ carrierForm: updatedCarrierForm, loading: false });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/phones?id=' + carrierId
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  getDriverPhones(driverId) {
    if (driverId === null || driverId === undefined || driverId === "") {
      return;
    }
    if (!this.state.loading) {
      this.setState({ loading: true });
    }

    axios({
      method: 'get',
      url: '/api/v1/drivers/phones?id=' + driverId,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        const updatedDriverForm = { ...this.state.driverForm };
        let phones = [];
        Object.keys(response.data).forEach(key => {
          phones.push({ phone: key, name: response.data[key] });
        });
        for (let i = 0; i < phones.length; i++) {
          phones[i] = { ...phones[i], driver: this.props.card.driver };
        }
        updatedDriverForm.phones.value = phones;
        this.setState({ driverForm: updatedDriverForm, loading: false });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/drivers/phones?id=' + driverId
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  parsePhones(phones) {
    let parsedPhones = [];
    Object.keys(phones).forEach(key => {
      parsedPhones.push({ phoneType: key, phoneNumber: phones[key] })
    });
    return parsedPhones;
  }

  getTripHistory(tripId) {
    if (tripId === null) {
      return;
    }
    axios({
      method: 'get',
      url: '/api/v1/carriers/history/trip?id=' + tripId.substring(1, tripId.length),
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.props.onSetTripCarrierHistory({ tripId: parseInt(this.props.card.trip.substring(1, this.props.card.trip.length)), history: [...response.data].reverse() });
      })
      .catch(error => {
        console.log(error);
        this.setState({ historyTripLoading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/history/trip?id=' + tripId.substring(1, tripId.length)
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  getHistory(carrierId) {
    if (carrierId === "-" || carrierId === "" || carrierId === null) {
      return;
    }
    if (!this.state.historyLoading) {
      this.setState({ historyLoading: true });
    }

    axios({
      method: 'get',
      url: '/api/v1/carriers/history?id=' + carrierId,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        console.log(response);
        this.setState({ history: response.data, historyLoading: false });
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/history?id=' + carrierId
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  componentWillUnmount() {
    this.props.onSetTripCarrierHistory(null);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.localCard === null && this.props.card != undefined && this.props.card.trip != undefined) {
      this.getTripHistory(this.props.card.trip);
      if (this.props.card.carrier !== null) {
        const updatedCarrierHolderForm = { ...this.state.carrierHolderForm };
        updatedCarrierHolderForm.carrier.elementConfig.options = this.createCarriers();
        updatedCarrierHolderForm.carrier.value = this.props.card.carrier;
        this.getPhones(this.props.card.carrier);
        this.setState({ carrierHolderForm: updatedCarrierHolderForm });
      }
      this.setState({ localCard: { ...this.props.card } });
    }

    if (this.props.card === null && this.state.localCard) {
      this.setState({ localCard: null });
    }

    if (this.state.carrierHolderForm.carrier.value !== prevState.carrierHolderForm.carrier.value) {
      this.getPhones(this.state.carrierHolderForm.carrier.value);
      this.getHistory(this.state.carrierHolderForm.carrier.value);
    }

    if (this.props.card && this.props.card.driver !== this.state.driver) {
      this.setState({ driver: this.props.card.driver });
      this.getDriverPhones(this.props.card.driver);
    }

    if (this.props.carriers !== prevProps.carriers) {
      const updatedCarriers = { ...this.state.carrierHolderForm };
      updatedCarriers.carrier.elementConfig.options = this.createCarriers();
      this.getPhones(this.state.carrierHolderForm.carrier.value);
      this.getHistory(this.state.carrierHolderForm.carrier.value);
      this.setState({ carrierHolderForm: updatedCarriers });
    }

    if (this.props.card === null && this.state.localCard !== null) {
      this.setState({ localCard: null });
    }

    if (this.state.carrierHolderForm.carrier.value !== prevState.carrierHolderForm.carrier.value) {
      if (this.state.carrierHolderForm.carrier.value < 0) {
        for (let i = 0; i < this.props.carriers.length; i++) {
          if (this.state.carrierHolderForm.carrier.value === this.props.carriers[i].id) {
            this.props.onShowNewCarrier(this.props.carriers[i]);
            break;
          }
        }
      }
    }

    if (prevProps.showNewCarrier && !this.props.showNewCarrier) {
      this.getPhones(this.state.carrierHolderForm.carrier.value);
      this.getHistory(this.state.carrierHolderForm.carrier.value);
    }

    if (prevProps.tripCarrierHistory !== this.props.tripCarrierHistory) {
      const updatedTripHistory = { ...this.state.tripCarrierHistory };
      updatedTripHistory.tripCarrier.value = this.props.tripCarrierHistory.history;
      this.setState({ tripCarrierHistory: updatedTripHistory });
    }
  }

  createCarriers() {
    if (this.props.card === null) {
      return;
    }
    let carriers = [];
    carriers.push({ value: "-", displayValue: "-" });
    let foundCarrier = false;
    for (let i = 0; i < this.props.carriers.length; i++) {
      let carrier = this.props.carriers[i];
      let carrierName = carrier.id <= 0 ? " " : carrier.id + " | ";
      carrierName += this.getAttribute(carrier, "okpo") + " | ";
      carrierName += this.getAttribute(carrier, "name") + " | ";
      carrierName += this.getAttribute(carrier, "name_partner") + " | ";
      carrierName += this.getAttribute(carrier, "name_ls");
      carriers.push({
        value: carrier.id,
        displayValue: carrierName
      });
      foundCarrier = foundCarrier || carrier.id === this.props.card.carrier;
    }
    if (!foundCarrier && this.props.card.carrier) {
      this.getCarrier(this.props.card.carrier);
    }
    return carriers;
  }

  getCarrier(carrierId) {
    if (carrierId === "" || carrierId === null) {
      return;
    }
    axios({
      method: 'get',
      url: '/api/v1/carriers/carrier?id=' + carrierId,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        const updatedForm = { ...this.state.carrierHolderForm };
        let carrierName = response.data.id <= 0 ? " " : response.data.id + " | ";
        carrierName += this.getAttribute(response.data, "okpo") + " | ";
        carrierName += this.getAttribute(response.data, "name") + " | ";
        carrierName += this.getAttribute(response.data, "name_partner") + " | ";
        carrierName += this.getAttribute(response.data, "name_ls");
        const updatedOptions = [{ value: "-", displayValue: "-" }];
        updatedOptions.push({ value: response.data.id, displayValue: carrierName });
        updatedForm.carrier.elementConfig.options = updatedOptions;
        updatedForm.carrier.value = response.data.id;
        this.setState({ carrierHolderForm: updatedForm });
      })
      .catch(error => {
        console.log(error.response);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/carriers/carrier?id=' + carrierId
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        } else if (!error.response) {
          this.props.addNotification("Помилка на сервері.", "Danger");
        }
      });
  }

  createManagers() {
    return this.props.managers.map((manager, index) => {
      return (
        { value: manager.name, displayValue: manager.name }
      )
    });
  }

  formatDate(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(2, 4) + " " + date.substring(11, 19);
  }

  checkValidity(value, rules) {
    let isValid = true;

    if (rules.required) {
      isValid = value.trim !== '' && isValid;
    }

    if (rules.type === 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isValid = re.test(value) && isValid;
    }

    if (rules.type == 'confirmPassword') {
      isValid = this.state.registerForm.password.value === value && isValid;
    }

    if (rules.minLength) {
      isValid = value.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value.length <= rules.maxLength && isValid;
    }

    return isValid;
  }

  getErrorMessage(value, rules) {
    let errorMessage = '';

    if (rules.required && value.trim === '') {
      errorMessage = 'Це поле обов\'язкове';
    }

    if (rules.type == 'email') {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(value)) {
        errorMessage = 'Введіть правильний email';
      }
    }

    if (rules.type == 'confirmPassword' && this.state.registerForm.password.value !== value) {
      errorMessage = 'Паролі повинні співпадати';
    }

    if (rules.minLength && value.length < rules.minLength) {
      errorMessage = 'Мінімальна довжина: ' + rules.minLength;
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      errorMessage = 'Максимальна довжина: ' + rules.minLength;
    }

    return errorMessage;
  }

  inputChangedHandler = (event, elementId) => {
    const updatedCarrierForm = {
      ...this.state.carrierForm
    }
    const updatedFormElement = {
      ...updatedCarrierForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedCarrierForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedCarrierForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    const updatedCard = { ...this.state.localCard };
    updatedCard[elementId] = event.target.value;
    this.setState({ carrierForm: updatedCarrierForm, localCard: updatedCard });
  }

  commentChangedHandler = (event, elementId) => {
    const updatedCommentForm = {
      ...this.state.commentForm
    }
    const updatedFormElement = {
      ...updatedCommentForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedCommentForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedCommentForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    this.setState({ commentForm: updatedCommentForm });
  }

  carrierChangedHandler = (event, elementId) => {
    const updatedCarrierForm = {
      ...this.state.carrierHolderForm
    }
    const updatedFormElement = {
      ...updatedCarrierForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedCarrierForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedCarrierForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    this.setState({ carrierHolderForm: updatedCarrierForm });
  }

  tripHistoryChangedHandler = (event, elementId) => {
    const updatedForm = {
      ...this.state.tripCarrierHistory
    }
    const updatedFormElement = {
      ...updatedForm[elementId]
    }

    if ((event.target.value === '' || event.target.value === null) &&
      updatedForm[elementId].elementConfig.type === 'number') {
      event.target.value = 0;
    }
    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedFormElement.valid = this.checkValidity(updatedFormElement.value,
      updatedFormElement.validation);
    updatedFormElement.errorMessage = this.getErrorMessage(updatedFormElement.value,
      updatedFormElement.validation);
    updatedForm[elementId] = updatedFormElement;
    let capacityFilled = null;

    this.setState({ tripCarrierHistory: updatedForm });
  }

  parseHistoryDate = (historyDate) => {
    return historyDate.substring(8, 10) + "/" + historyDate.substring(5, 7) + " " + historyDate.substring(11, 16);
  }

  editCarrier(ev) {
    ev.preventDefault();
    for (let i = 0; i < this.props.carriers.length; i++) {
      if (this.state.carrierHolderForm.carrier.value === this.props.carriers[i].id) {
        this.props.onShowNewCarrier(this.props.carriers[i]);
        break;
      }
    }
  }

  getRecentHistory(history) {
    let displayHistory = [];
    if (history) {
      if (history.length >= 1) {
        displayHistory.push(history[history.length - 1]);
      }
    }
    return displayHistory.length == 0 ?
      <p className={classes.HistoryEntry}>Нет истории Перевозчика.</p>
      : displayHistory.map(history => {
        return (
          <p className={classes.HistoryEntry}>
            {this.formatDate(history.historyDate)} ({history.username.substring(0, history.username.indexOf('@'))}): {history.note}
          </p>);
      });
  }

  render() {
    let addHistory = (event) => {
      event.preventDefault();
      this.setState({ historyLoading: true });
      axios({
        method: 'post',
        data: {
          carrierID: this.state.carrierHolderForm.carrier.value,
          note: this.state.commentForm.comment.value,
          historyDate: null
        },
        url: '/api/v1/carriers/history',
        headers: { 'Authorization': 'Bearer ' + this.props.access_token },
      })
        .then(response => {
          console.log(response);
          const updatedCommentForm = { ...this.state.commentForm };
          updatedCommentForm.comment.value = '';
          let updatedHistory = []
          if (this.state.history) {
            updatedHistory = [...this.state.history];
          }
          updatedHistory.push(response.data);
          this.setState({
            historyLoading: false,
            commentForm: updatedCommentForm,
            history: updatedHistory
          });
        })
        .catch(error => {
          console.log(error);
          this.setState({ historyLoading: false });
          if (error.response) {
            logError(
              this.props.access_token,
              this.props.codeToMessage[error.response.status],
              '/api/v1/carriers/history'
            );
            this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
          }
        });
    }

    let show = true;
    let card = null;

    if (this.state.localCard === null) {
      card = null;
      show = false;
    } else {

      const carrierFormArray = [];
      for (let key in this.state.carrierForm) {
        carrierFormArray.push({ id: key, config: this.state.carrierForm[key] });
      }

      const driverFormArray = [];
      for (let key in this.state.driverForm) {
        driverFormArray.push({ id: key, config: this.state.driverForm[key] });
      }

      const commentFormArray = [];
      for (let key in this.state.commentForm) {
        commentFormArray.push({ id: key, config: this.state.commentForm[key] });
      }

      const carrierHolderFormArray = [];
      for (let key in this.state.carrierHolderForm) {
        carrierHolderFormArray.push({ id: key, config: this.state.carrierHolderForm[key] });
      }

      const tripHistoryArray = [];
      for (let key in this.state.tripCarrierHistory) {
        tripHistoryArray.push({ id: key, config: this.state.tripCarrierHistory[key] });
      }


      let loading = null;
      if (this.state.loading) {
        loading = (
          <Spinner />
        )
      }

      let history = null;
      if (this.state.history) {
        history = (
          <ul className={classes.HistoryList}>
            {
              this.state.history.map((hist) => {
                return (
                  <li className={classes.HistoryEntry}>
                    {this.formatDate(hist.historyDate)} ({hist.username.substring(0, hist.username.indexOf('@'))}): {hist.note}
                  </li>
                )
              })
            }
          </ul>
        );
      }

      let shortHistory = null;
      if (this.state.historyLoading) {
        shortHistory = <Spinner />;
      } else {
        shortHistory = this.getRecentHistory(this.state.history);
      }

      let headerClasses = [classes.Header];
      headerClasses.push(classes.HeaderWhite);

      let sideBySideButton = (
        <ButtonIcon
          btnClass={classes.ButtonIconRound}
          clicked={(ev) => this.sideBySide(ev)}
          iconClass={classes.Icon}
          iconSource={sideBySideImg}
          small
          iconAlt=''></ButtonIcon>);

      if (this.props.sideBySideMode) {
        sideBySideButton = (
          <ButtonIcon
            btnClass={classes.ButtonIconRound}
            clicked={(ev) => this.sideBySide(ev)}
            iconClass={classes.Icon}
            iconSource={stackedImg}
            small
            iconAlt=''></ButtonIcon>);
      }

      card = (
        <Aux>
          <Modal
            loading={this.state.historyLoading}
            show={this.state.showHistory}
            modalClosed={() => this.setState({ showHistory: false })} >
            <div className={classes.HistoryHolder}>

              {history}

              <div className={classes.HistoryFooter}>
                <Button
                  btnType={['Success', 'NoMargin']}
                  clicked={() => this.setState({ showHistory: false })}>
                  ЗАКРЫТЬ
                </Button>
              </div>
            </div>
          </Modal>

          <Modal
            loading={this.state.historyTripLoading}
            show={this.state.showTripHistory}
            modalClosed={() => this.setState({ showTripHistory: false })} >
            <div className={classes.HistoryHolder}>

              <div className={classes.HistoryFooter}>
                <Button
                  btnType={['Success', 'NoMargin']}
                  clicked={() => this.setState({ showTripHistory: false })}>
                  ЗАКРЫТЬ
                </Button>
              </div>
            </div>
          </Modal>
          <div className={headerClasses.join(' ')}>

            <div className={classes.CarrierTitle}>
              <Icon iconClass={classes.CarIcon} iconSource={personImg} iconAlt='' className={classes.CardIcon} />
              {this.props.name}
            </div>

            {sideBySideButton}

            <button className={classes.CloseButton} onClick={this.props.closeCard}>
              <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
            </button>
            <p style={{ height: "100%" }}></p>
          </div>

          <div className={classes.Body} >
            {loading}
            {carrierHolderFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.carrierChangedHandler(event, formElement.id)} />
              );
            })}


            <div className={classes.CommentHolder}>
              {shortHistory}
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => this.setState({ showHistory: true })}
                disabled={this.state.historyLoading}
                iconClass={classes.ButtonIcon}
                iconSource={historyImg}
                small
                style={{ width: "auto", height: "auto", paddingLeft: "10px", paddingRight: "10px" }}
                iconAlt=''></ButtonIcon>
            </div>
            <div className={classes.CommentHolder}>
              {commentFormArray.map(formElement => {
                return (
                  <Input
                    key={formElement.id}
                    label={formElement.config.label}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    extraClass={formElement.config.extraClass}
                    extraAction={formElement.config.extraAction}
                    changed={(event) => this.commentChangedHandler(event, formElement.id)} />
                );
              })}
              <ButtonIcon
                btnType='Success'
                clicked={(ev) => addHistory(ev)}
                disabled={this.state.historyLoading}
                iconClass={classes.ButtonIcon}
                iconSource={saveImg}
                small
                style={{ width: "auto", height: "auto", paddingLeft: "10px", paddingRight: "10px" }}
                iconAlt=''></ButtonIcon>
            </div>

            {carrierFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}

            {driverFormArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
            })}

            {tripHistoryArray.map(formElement => {
              return (
                <Input
                  key={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  extraClass={formElement.config.extraClass}
                  extraAction={formElement.config.extraAction}
                  changed={(event) => this.tripHistoryChangedHandler(event, formElement.id)} />
              );
            })}

          </div>

          {loading}

          <div className={classes.Footer}>

            <div className={classes.FooterButtons}>
            </div>
          </div>
        </Aux>
      );
    }

    let carrierClass = classes.CardModal;
    if (this.props.tripleMode) {
      carrierClass = classes.TrippleCardModal;
    } else if (this.props.sideBySideMode) {
      carrierClass = classes.FullCardModal;
    }

    return (
      <Aux>
        <div
          className={carrierClass}
          style={{
            transform: show ? 'translateY(0)' : 'translateY(-100vh)',
            opacity: show ? '1' : '0'
          }}>
          {card}
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    managers: state.managers,
    requests: state.requests,
    drivers: state.drivers,
    locations: state.locations,
    carriers: state.carriers,
    showNewCarrier: state.showNewCarrier,
    sideBySideMode: state.sideBySideMode,
    tripleMode: state.tripleMode,
    role: state.role,
    tripCarrierHistory: state.tripCarrierHistory,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onSetTripCarrierHistory: (tripCarrierHistory) => dispatch({
      type: actionTypes.SET_TRIP_CARRIER_HISTORY,
      tripCarrierHistory: tripCarrierHistory
    }),
    onShowNewCarrier: (showNewCarrier) => dispatch({ type: actionTypes.SHOW_NEW_CARRIER, showNewCarrier: showNewCarrier }),
    onSetCarriers: (carriers) => dispatch({
      type: actionTypes.SET_CARRIERS,
      carriers: carriers
    }),
    onSetSideBySide: (sideBySide) => dispatch({
      type: actionTypes.SET_SIDE_BY_SIDE,
      sideBySide: sideBySide
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarrierModal);



// WEBPACK FOOTER //
// ./src/components/CarrierModal/CarrierModal.js